import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthClienteService } from '../services/authCliente.service';

@Injectable({
  providedIn: 'root'
})
export class AuthClienteGuard implements CanActivate, CanActivateChild {
  constructor(private auth: AuthClienteService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.check();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.check();
  }

  // SECURITY: `isLoggedIn` richiede LoggedInCustomer + apiToken presente e non
  // scaduto (fail-closed). Se manca, ha già fatto il logout pulito
  // (`resetUser`, che azzera anche il `token` magic-link → niente loop di
  // auto-login): qui resta solo il redirect al login cliente.
  private check(): boolean {
    if (this.auth.isLoggedIn()) {
      return true;
    }
    this.router.navigateByUrl('/login');
    return false;
  }
}
